<script setup>
</script>

<template>
    <small class="copyright-sanpaolo">
    <svg style="width:14px;height:14px; opacity: .7;" viewBox="0 0 24 24">
        <path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
    </svg>
        <span>Il testo biblico è tratto da <a rel="nofollow" href="https://www.edizionisanpaolo.it/">LA BIBBIA. 
        Nuova versione dai testi originali</a>, San Paolo Edizioni 2010.</span>
    </small>
</template>